import React from "react";
import { connect } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";


// REDUX ACTIONS
import { logout } from "../../redux/actions/auth";
// CSS STYLES
import styles from "../../styles/AuthenticationLogin/SignOutModal.module.css"
// ICONS
import { IoClose } from "react-icons/io5";



const SignOutModal = ({
    open,
    closeModal,
    // REDUX ACTIONS
    logout,
}) => {

    const navigate = useNavigate()


    const handleClose = (e) => {
        if (e.target.attributes['data-action']?.value === 'close') {
			closeModal()
		}
    }

    const handleLogOut = async (e) => {
        e.preventDefault();
        await logout();
        closeModal()
        // return <Navigate to="/" />;
        navigate('/')
    }

    return open && (
        <div className={styles.signOut_modal_wrapper}>
            <div className={styles.signOut_card_container}>
                {/* FLOATING CLOSE ICON */}
                <IoClose className={styles.IoClose} size={22} data-action="close" onClick={(e) => { handleClose(e) }} />
                {/* HEADR TEXT */}
                <p className={styles.header_text}>Confirm Log Out?</p>
                {/* BUTTONS */}
                <div className={styles.button_container}>
                    <button 
                        className={styles.signOut_button_cancel}
                        data-action="close"
                        onClick={(e) => { handleClose(e) }}
                    >
                        Cancel
                    </button>
                    <button 
                        className={styles.signOut_button_logout}
                        onClick={(e) => { handleLogOut(e) }}
                    >
                        Logout
                    </button>
                </div>
            </div>
            
        </div>
    );
};

const mapStateToProps = (state) => ({
    //
});

export default connect(mapStateToProps, {
    logout
})(SignOutModal);
